import { ModButton, ModIconButton } from '@moderneinc/design-system-components';
import {
  borderRadius,
  iconSize,
  semanticColors,
  shadows,
  spacing,
  typography
} from '@moderneinc/design-system-tokens';
import { Box, Stack, Typography } from '@mui/material';
import Image from 'next/image';
import { useRouter } from 'next/router';
import type { FunctionComponent } from 'react';
import { useState } from 'react';
import { toBoxShadow } from '../../../helpers/shadow.helper';
import { CloseIcon } from '../../../icons/icons';

const CARD_WIDTH = 300;
const IMAGE_HEADER_HEIGHT = 88;

export const UpdateApplication: FunctionComponent = () => {
  const { reload } = useRouter();
  const [dismissed, setDismissed] = useState(false);

  if (dismissed) {
    return null;
  }

  return (
    <Box
      sx={{
        position: 'relative',
        width: CARD_WIDTH,
        backgroundColor: semanticColors.color.surface.raised,
        border: `1.5px solid ${semanticColors.color.border.primary}`,
        borderRadius: `${borderRadius.card}px`,
        overflow: 'hidden',
        boxShadow: toBoxShadow(shadows.neutral.medium)
      }}
    >
      <Image
        src="/saas-announcement-scene-2.png"
        alt=""
        width={CARD_WIDTH}
        height={IMAGE_HEADER_HEIGHT}
        style={{
          display: 'block',
          width: '100%',
          height: IMAGE_HEADER_HEIGHT,
          objectFit: 'cover',
          objectPosition: 'center top'
        }}
      />
      <ModIconButton
        size="small"
        aria-label="Dismiss update notification"
        onClick={() => setDismissed(true)}
        sx={{
          position: 'absolute',
          top: spacing.spacing_1_2,
          right: spacing.spacing_1_2
        }}
      >
        <CloseIcon size={iconSize.sm} />
      </ModIconButton>
      <Box sx={{ padding: `${spacing.spacing_1}px` }}>
        <Stack sx={{ gap: `${spacing.spacing_1}px` }}>
          <Typography
            sx={{
              fontSize: typography.fontSize.default,
              fontWeight: typography.fontWeight.semiBold,
              color: semanticColors.color.text.primary,
              lineHeight: 1.4
            }}
          >
            A new version of Moderne is available
          </Typography>
          <Stack
            direction="row"
            sx={{
              gap: `${spacing.spacing_1_2}px`,
              justifyContent: 'flex-end'
            }}
          >
            <ModButton
              variant="tertiary"
              size="small"
              onClick={() => setDismissed(true)}
            >
              Dismiss
            </ModButton>
            <ModButton variant="secondary" size="small" onClick={reload}>
              Reload
            </ModButton>
          </Stack>
        </Stack>
      </Box>
    </Box>
  );
};
